import Vue from "vue"
import { vuexfireMutations, firestoreAction } from "vuexfire"

const getDefaultState = () => {
	return {
		current: {},
		invoices: [],
	}
}

export const state = () => ({
	current: {},
	invoices: [],
})

export const mutations = {
	...vuexfireMutations,
	RESET_STATE(state) {
		Object.assign(state, getDefaultState())
	},
	UPDATE_FIELD(state, { field, value }) {
		Vue.set(state.current, field, value)
	},
}

export const actions = {
	bind: firestoreAction(async function ({ bindFirestoreRef }, payload) {
		// Risk , enquiry, quote id
		const ref = this.$fire.firestore
			.collection(`risks/${payload.risk_id}/enquiries/${payload.enquiry_id}/policies`)
			.doc(payload.policy_id)
		await bindFirestoreRef("current", ref, { wait: true })
	}),
	unbind: firestoreAction(function ({ unbindFirestoreRef }) {
		unbindFirestoreRef("current", () => {
			return {}
		})
	}),
	bindInvoices: firestoreAction(async function ({ bindFirestoreRef }, path) {
		// Risk , enquiry, quote id
		const ref = this.$fire.firestore.collection(`${path}/invoices`)
		await bindFirestoreRef("invoices", ref, { wait: true, maxRefDepth: 1 })
	}),
	unbindInvoices: firestoreAction(function ({ unbindFirestoreRef }) {
		unbindFirestoreRef("invoices", () => {
			return []
		})
	}),
	reset({ commit, dispatch }) {
		dispatch("unbind")
		dispatch("unbindInvoices")
		commit("RESET_STATE")
	},
}

export const getters = {
	getCurrent(state) {
		return state.current
	},
	getInvoices(state) {
		return state.invoices
	},
}
